import type { User } from "@supabase/supabase-js";

/**
 * 정수강생(유료 수강 회원) 판정 — **판정 정본 한 곳**.
 *
 * 2026-08-18 현재 수강권·결제 체계가 아직 없어, 로그인 회원이면 커뮤니티 쓰기를
 * 허용한다(정책 A). 이 함수는 지금 전원 false(=일반)를 돌려주지만, 나중에
 * kangstudy_enrollments(수강내역) 가 생기면 **여기만 바꾸면** 배지·권한이 전부
 * 따라온다. 소비 지점(배지 표시·글쓰기 게이트)에 판정을 인라인하지 말 것.
 *
 * 참고: 실제 "정수강생만 쓰기" 제한을 켜려면 이 함수를 채운 뒤
 * WritePostModal 게이트를 isPaidMember 로 바꾸면 된다(지금은 로그인 여부만 봄).
 */
export function isPaidMember(_user: User | null): boolean {
  // TODO: 수강권 체계 완성 시 — 예: user.app_metadata.paid_until > now,
  // 또는 kangstudy_enrollments 조회 결과를 받아 판정.
  return false;
}

/** 커뮤니티에 표시할 작성자 배지. 판정 정본(isPaidMember)에서만 파생. */
export function authorBadge(user: User | null): string | null {
  if (!user) return null;
  return isPaidMember(user) ? "정수강생" : null;
}
